import React from 'react';

import ThemeContext from '../../context/themeContext';

const ThemeToggle = () => {

    const buttonStyles = {
        '--button-icon-only-size': '2.5em',
        '--button-icon-over-text-width': 'auto'
    };

	return (
		<ThemeContext.Consumer>
			{({ handleTheme }) => {
				return (
					<div className='theme-picker' style={buttonStyles}>
						<button
							className='button button--icon-over-text'
							onClick={handleTheme}
						>
						<span className='button__icon border-radius-circle'>
							<span
								className='icon icon-mode-light-dark'
								aria-hidden='true'
							></span>
						</span>
							<span className='button__text'>Theme</span>
						</button>
					</div>
				);
			}}
		</ThemeContext.Consumer>
	);
};

export default ThemeToggle;